import React from "react";
import { SectionHead } from "./Portfolio";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  { q: "Que ficheiros posso enviar?", a: "Aceitamos STL, STEP, OBJ, 3MF e ZIP (até 60 MB cada). Se tiver o modelo noutro formato, contacte-nos por WhatsApp." },
  { q: "Como funciona o orçamento?", a: "Cada pedido é avaliado caso a caso. Depois de receber o seu ficheiro e requisitos, respondemos com uma proposta detalhada, normalmente em menos de 2 horas úteis." },
  { q: "Quanto tempo demora a produção?", a: "Depende da peça, tecnologia e quantidade. Indicamos sempre o prazo estimado na proposta. Muitas peças ficam prontas em 24 a 72h." },
  { q: "Fazem peças únicas e pequenas séries?", a: "Sim. Produzimos desde uma peça única de reposição até pequenas séries para produção. Diga-nos a quantidade no formulário." },
  { q: "Os meus modelos ficam confidenciais?", a: "Sim. Os seus ficheiros CAD são tratados de forma confidencial e usados apenas para produzir a sua peça. Assinamos NDA se o pedir." },
  { q: "Como recebo a peça?", a: "Após aprovação da proposta, produzimos e enviamos por correio expresso para todo o país, normalmente em 24/48h." },
];

export const Faq = () => (
  <div data-testid="faq-section">
    <SectionHead eyebrow="Perguntas frequentes" title="Tudo o que precisa de saber" />
    <div className="mt-10 max-w-3xl">
      <Accordion type="single" collapsible className="space-y-3">
        {FAQS.map((f, i) => (
          <AccordionItem key={f.q} value={`faq-${i}`} data-testid={`faq-item-${i}`}
            className="bg-ax-card border border-ax-border rounded-xl px-5 overflow-hidden">
            <AccordionTrigger className="text-left font-heading font-semibold text-ax-text hover:no-underline py-5">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-ax-sub leading-relaxed pb-5">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </div>
);
